import { render, staticRenderFns } from "./GolfSkillsAssessmentEditDialog.vue?vue&type=template&id=44086b04&"
import script from "./GolfSkillsAssessmentEditDialog.vue?vue&type=script&lang=js&"
export * from "./GolfSkillsAssessmentEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports